import { type VariantProps } from 'class-variance-authority';
import { ReactNode } from 'react';
import { iconButtonVariants } from './logic';

type ButtonProps = Omit<React.ComponentProps<'button'>, 'aria-label'>;
type Props = ButtonProps &
  VariantProps<typeof iconButtonVariants> & {
    icon: ReactNode;
    'aria-label': string;
  };

export const IconButton: React.FC<Props> = ({
  variant = 'primary',
  size = 'md',
  icon,
  ...props
}) => {
  const { className, type, ...rest } = props;
  const buttonType = type ?? 'button';
  const mergedClassName = [iconButtonVariants({ variant, size }), className]
    .filter(Boolean)
    .join(' ');

  return (
    <button type={buttonType} className={mergedClassName} {...rest}>
      {icon}
    </button>
  );
};
